import {PROPERTY_TYPE_ALL, isPropertyTypeAll} from './property-types';
import {UNREFINED_KEY, isUnrefined} from './listings';

export function pushEdapEvent(event, eventOptions, edapOptions) {
    window.edap.push((edap) => edap.trigger(event, eventOptions, edapOptions));
}

export function getRefinements({
    propertyType = PROPERTY_TYPE_ALL,
    refinementKey = UNREFINED_KEY,
    position
}) {
    const eventrefinements = [];
    if (!isPropertyTypeAll(propertyType)) {
        eventrefinements.push(propertyType);
    }
    if (!isUnrefined(refinementKey)) {
        eventrefinements.push(position ? `filter:${refinementKey},position:${position}` : `filter:${refinementKey}`);
    }

    return eventrefinements.join(',');
}
